import { render, staticRenderFns } from "./HumanResourcesMatrix.vue?vue&type=template&id=ae7556ba"
import script from "./HumanResourcesMatrix.vue?vue&type=script&lang=js"
export * from "./HumanResourcesMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports